/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Openapi_SpecsInputs */

const en_svchip_openapi_specs = /** @type {(inputs: Svchip_Openapi_SpecsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAPI specs`)
};

const ar_svchip_openapi_specs = /** @type {(inputs: Svchip_Openapi_SpecsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مواصفات OpenAPI`)
};

const bn_svchip_openapi_specs = /** @type {(inputs: Svchip_Openapi_SpecsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAPI স্পেক`)
};

const de_svchip_openapi_specs = /** @type {(inputs: Svchip_Openapi_SpecsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAPI-Spezifikationen`)
};

const es_svchip_openapi_specs = /** @type {(inputs: Svchip_Openapi_SpecsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Especificaciones de OpenAPI`)
};

const fr_svchip_openapi_specs = /** @type {(inputs: Svchip_Openapi_SpecsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spécifications OpenAPI`)
};

const pt_svchip_openapi_specs = /** @type {(inputs: Svchip_Openapi_SpecsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Especificações OpenAPI`)
};

const zh_svchip_openapi_specs = /** @type {(inputs: Svchip_Openapi_SpecsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAPI 规范`)
};

const tr_svchip_openapi_specs = /** @type {(inputs: Svchip_Openapi_SpecsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAPI özellikleri`)
};

const ru_svchip_openapi_specs = /** @type {(inputs: Svchip_Openapi_SpecsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спецификации OpenAPI`)
};

const pl_svchip_openapi_specs = /** @type {(inputs: Svchip_Openapi_SpecsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specyfikacje OpenAPI`)
};

/**
* | output |
* | --- |
* | "OpenAPI specs" |
*
* @param {Svchip_Openapi_SpecsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_openapi_specs = /** @type {((inputs?: Svchip_Openapi_SpecsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Openapi_SpecsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_openapi_specs(inputs)
	if (locale === "bn") return bn_svchip_openapi_specs(inputs)
	if (locale === "de") return de_svchip_openapi_specs(inputs)
	if (locale === "es") return es_svchip_openapi_specs(inputs)
	if (locale === "fr") return fr_svchip_openapi_specs(inputs)
	if (locale === "pt") return pt_svchip_openapi_specs(inputs)
	if (locale === "zh") return zh_svchip_openapi_specs(inputs)
	if (locale === "tr") return tr_svchip_openapi_specs(inputs)
	if (locale === "ru") return ru_svchip_openapi_specs(inputs)
	if (locale === "pl") return pl_svchip_openapi_specs(inputs)
	return en_svchip_openapi_specs(inputs)
});